import { createDispatchFunction, dispatchPromise } from 'shared/helpers';
import { partial, isEmpty } from 'lodash';
import SeatingChartService from './SeatingChartService';

// Actions
const GET_REG_SUMMARIES = 'seatingChart/GET_REG_SUMMARIES';
const ASSIGN_REGS = 'seatingChart/ASSIGN_REGS';
const ASSIGN_MATERIALS_TO_REGS = 'seatingChart/ASSIGN_MATERIALS_TO_REGS';
const GET_STUDENTS_LIST = 'rooms/GET_STUDENTS_LIST';

const initialState = {
  regSummaries: [],
  studentsList: [],
  loading: false,
};


// Reducer
export default function seatingChartReducer(state = initialState, action = {}) {
  switch (action.type) {
    case GET_REG_SUMMARIES:
      return {
        ...state,
        regSummaries: action.result.data || [],
        loading: action.result.loading ? true : undefined,
      };
    case GET_STUDENTS_LIST:
      return {
        ...state,
        studentsList: action.result.data?.data || [],
      };
    default:
      return state;
  }
}

// Action Creators
export function getRegSummariesAction(result) {
  return { type: GET_REG_SUMMARIES, result };
}

export function assignRegsAction(result) {
  return { type: ASSIGN_REGS, result };
}

export function assignMaterialsToRegsAction(result) {
  return { type: ASSIGN_MATERIALS_TO_REGS, result };
}

export function getStudentsListAction(result) {
  return { type: GET_STUDENTS_LIST, result}
}


// Action dispatcher functions
export function getRegSummaries(roomId) {
  return createDispatchFunction(
    partial(SeatingChartService.getRegSummaries, roomId),
    getRegSummariesAction
  )
}

export function assignRegs(locationEventId, data) {
  return createDispatchFunction(
    partial(SeatingChartService.assignRegs, locationEventId, data),
    assignRegsAction
  )
}

export function assignMaterialsToRegs(roomId, data) {
  return createDispatchFunction(
    partial(SeatingChartService.assignMaterialsToRegs, roomId, data),
    assignMaterialsToRegsAction
  )
}

export function getStudentsList(roomId) {
  return createDispatchFunction(
    partial(SeatingChartService.getStudentsList, roomId),
    getStudentsListAction
  );
}
